import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom"
import { workqueueActions } from "../../../store/workqueue";
import { filterActions } from "../../../store/filter";
import { customWorkQSlugs } from "../pages/custom/globalWorkQStructure";


export default function CheckSetQueue({list, setIsListOpened}) {
    const location = useLocation()
    let { workqSlug } = useParams();
    const dispatch = useDispatch()
    const selectedWorkQueue = useSelector((state) => state.workqueue.selectedWorkQueue);

    if (!workqSlug) {
        customWorkQSlugs.forEach(item => {
            if (location.pathname.includes(item)) {
                workqSlug = item
            }
        })
    }

    useEffect(() => {
        if (workqSlug && selectedWorkQueue) {
            if (workqSlug !== selectedWorkQueue.slug) {
                if (setIsListOpened) {
                    setIsListOpened(false)
                }
                if (list) {
                    dispatch(workqueueActions.setSelectedWorkQueue(list.find(item => item.slug == workqSlug)))
                }
                dispatch(filterActions.setFiltersMultiple(null))
                dispatch(filterActions.setSearchParams({}))
                dispatch(filterActions.setExceptionsBatch({}))
                dispatch(filterActions.clearWorkQSearch())
            }           
            
        }

    }, [location, selectedWorkQueue]) 
}